export function useStoryblokVersion(): 'draft' | 'published' {
    const route = useRoute();
    const config = useRuntimeConfig();

    const isDraft = !!route.query._storyblok || config.public.includeDraft;

    return isDraft ? 'draft' : 'published';
}
